import React, { Component } from "react";
import styles from "./speedColorControl.module.scss";
import SpeedIcon from "@mui/icons-material/Speed";
import TooltipWrapper from "../../shared/items/contols/tooltipWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { withRouteSpeedColor } from "../../shared/containers/containerRouteSpeedColor";
import { Checkbox } from "@mui/material";
import { ColorPicker } from "material-ui-color";
import TextField from "@mui/material/TextField";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

class SpeedColorControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  checkboxClickHandler() {
    const { routeSpeedColor, onSetRouteSpeedColor } = this.props;
    routeSpeedColor.isOn = !routeSpeedColor.isOn;

    onSetRouteSpeedColor(routeSpeedColor);
  }

  changeColorHandler(hex, index) {
    const { routeSpeedColor, onSetRouteSpeedColor } = this.props;

    routeSpeedColor.items[index].color = `#${hex}`;
    onSetRouteSpeedColor(routeSpeedColor);
  }

  changeSpeedMinHandler(speed, index) {
    const { routeSpeedColor, onSetRouteSpeedColor } = this.props;

    let inputValue = parseInt(speed, 10);

    if (isNaN(inputValue)) {
      routeSpeedColor.items[index].min = null;
    } else {
      routeSpeedColor.items[index].min = inputValue;
    }

    onSetRouteSpeedColor(routeSpeedColor);
  }

  changeSpeedMaxHandler(speed, index) {
    const { routeSpeedColor, onSetRouteSpeedColor } = this.props;

    let inputValue = parseInt(speed, 10);

    if (isNaN(inputValue)) {
      routeSpeedColor.items[index].max = null;
    } else {
      routeSpeedColor.items[index].max = inputValue;
    }

    onSetRouteSpeedColor(routeSpeedColor);
  }

  addItemHandleClick() {
    const { routeSpeedColor, onSetRouteSpeedColor } = this.props;

    const lastIndex = routeSpeedColor.items.length - 1;

    const item = {
      min: parseInt(routeSpeedColor.items[lastIndex].max) + 1,
      max: parseInt(routeSpeedColor.items[lastIndex].max) + 1,
      color: routeSpeedColor.items[lastIndex].color,
    };

    routeSpeedColor.items = routeSpeedColor.items.concat(item);

    onSetRouteSpeedColor(routeSpeedColor);
  }

  removeItemHandleClick(index) {
    const { routeSpeedColor, onSetRouteSpeedColor } = this.props;

    routeSpeedColor.items.splice(index, 1);

    if (index < routeSpeedColor.items.length - 1) {
      routeSpeedColor.items[index].min = routeSpeedColor.items[index - 1].max + 1;
    }

    onSetRouteSpeedColor(routeSpeedColor);
  }

  render() {
    const { routeSpeedColor } = this.props;
    const { isOpen } = this.state;

    const disableAdd = routeSpeedColor.items.some((x) => {
      return x.max === null;
    });

    if (!isOpen) {
      return (
        <div
          className={styles.speedControl_control_container}
          style={{ border: routeSpeedColor.isOn ? "1px solid #7fff00" : "1px solid black" }}
        >
          <TooltipWrapper title={"Открыть панель скорости"} position="left">
            <div className={styles.speedControlsIconControl} onClick={() => this.setState({ isOpen: true })}>
              <SpeedIcon />
            </div>
          </TooltipWrapper>
        </div>
      );
    }

    return (
      <div className={styles.speedControl_control_container}>
        <div className={styles.speedControlItemContent}>
          <TooltipWrapper title={"Закрыть панель скорости"} position="left">
            <div className={styles.speedControlsIconControlClose} onClick={() => this.setState({ isOpen: false })}>
              <HighlightOffIcon fontSize="small" />
            </div>
          </TooltipWrapper>

          <div className={styles.itemCheckBoxControl}>
            <Checkbox
              key={routeSpeedColor.isOn}
              checked={routeSpeedColor.isOn}
              onChange={this.checkboxClickHandler.bind(this)}
              style={{
                padding: "0px",
                transform: "scale(1)",
              }}
            />
            <span>
              {" "}
              <b>Цвет на маршруте</b>
            </span>
          </div>

          {routeSpeedColor.isOn
            ? routeSpeedColor.items.map((item, index) => {
                return (
                  <div key={index} className={styles.itemControl}>
                    <div className={styles.itemColorPicker}>
                      <ColorPicker
                        value={item.color}
                        hideTextfield={true}
                        onChange={(e) => {
                          this.changeColorHandler(e.hex, index);
                        }}
                      />
                      <b style={{ minWidth: "10px" }}> C </b>

                      <div style={{ padding: "5px" }}>
                        <TextField
                          id="outlined-basic"
                          label="км./ч."
                          variant="outlined"
                          value={item.min}
                          type="number"
                          sx={{
                            width: 90,
                            "& .MuiOutlinedInput-input": {
                              padding: "5.5px 14px", // Adjust the height as needed
                            },
                          }}
                          onChange={(e) => {
                            this.changeSpeedMinHandler(e.target.value, index);
                          }}
                        />
                      </div>

                      <b style={{ minWidth: "10px" }}> до </b>

                      <div style={{ padding: "5px" }}>
                        <TextField
                          id="outlined-basic"
                          label="км./ч."
                          variant="outlined"
                          value={item.max}
                          type="number"
                          sx={{
                            width: 90,
                            "& .MuiOutlinedInput-input": {
                              padding: "5.5px 14px", // Adjust the height as needed
                            },
                          }}
                          onChange={(e) => {
                            this.changeSpeedMaxHandler(e.target.value, index);
                          }}
                        />
                      </div>

                      <div style={{ paddingLeft: "5px", minWidth: "50px" }}>
                        {index !== 0 ? (
                          <TooltipWrapper title={"Удалить элемент"} position="top">
                            <RemoveCircleOutlineIcon
                              fontSize="small"
                              onClick={() => {
                                this.removeItemHandleClick(index);
                              }}
                            />
                          </TooltipWrapper>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })
            : null}

          {routeSpeedColor.isOn && !disableAdd ? (
            <div className={styles.addItemControl} onClick={this.addItemHandleClick.bind(this)}>
              <ControlPointIcon fontSize="small" /> <b>Добавить новый элемент</b>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouteSpeedColor(SpeedColorControl);
